import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const TwoFactorContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const TwoFactorIcon = styled(Box)(() => ({
  marginBottom: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const TwoFactorTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const TwoFactorSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  marginBottom: "44px",
  maxWidth: "400px",
}));

export const TwoFactorForm = styled("form")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
}));

export const TwoFactorActions = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  marginTop: "16px",
}));
